import { headers as bearerHeaders } from "../../endpoints/market-intelligence";
import endpoints from "../../endpoints";

// Shared agent-run helpers (Content Hub + Autopilot, 2026-10-01). Same contract as ContentHubComponent.runAgent/waitAgent:
// POST /agent/run → { runId }; 402 → e.outOfCredits; GET /agent/run/{id} polled until a terminal status.
export async function runAgent(agent, userMessage, parameters) {
  const base = String(endpoints.product.root || "");
  const h = await bearerHeaders();
  h["content-type"] = "application/json";
  const r = await fetch(`${base}/agent/run`, {
    method: "POST",
    headers: h,
    body: JSON.stringify({
      agent,
      instruction: userMessage,
      parameters
    })
  });
  const text = await r.text();
  let j = {};
  try {
    j = JSON.parse(text);
  } catch (e) {/* not json */}
  if (r.status === 402) {
    const e = new Error(j && j.error || "Out of generation credits.");
    e.outOfCredits = true;
    throw e;
  }
  if (!r.ok) throw new Error(j && j.error || `Agent run failed (${r.status})`);
  return j;
}

// `onTick(run)` (optional) sees every polled run row, so a view can show progress from the run context before it completes.
export async function waitAgent(runId, everyMs, maxTries, isAlive, onTick) {
  const base = String(endpoints.product.root || "");
  for (let i = 0; i < maxTries && (!isAlive || isAlive()); i++) {
    await new Promise(res => setTimeout(res, everyMs));
    try {
      const h = await bearerHeaders();
      const r = await fetch(`${base}/agent/run/${encodeURIComponent(runId)}`, {
        headers: h
      });
      const run = await r.json();
      if (onTick) {
        try {
          onTick(run);
        } catch (e) {/* a progress line never fails the wait */}
      }
      const status = String(run.status || run.Status || "").toLowerCase();
      if (status === "completed" || status === "complete" || status === "succeeded" || status === "success") {
        let ctx = {};
        try {
          ctx = JSON.parse(run.contextOutput || run.ContextOutput || "{}");
        } catch (e) {/* ignore */}
        let res = {};
        try {
          res = JSON.parse(run.runResult || run.RunResult || "{}");
        } catch (e) {/* ignore */}
        return {
          ok: true,
          ctx,
          res,
          run
        };
      }
      if (status === "failed" || status === "error" || status === "cancelled") return {
        ok: false,
        run
      };
    } catch (e) {/* retry */}
  }
  return {
    ok: false,
    timeout: true
  };
}
export const runIdOf = r => r && (r.runId || r.id || r.agentRunId || r.Id);

// The bulk actions the Assets tab can propose and the Autopilot content lane can run (Tier 2, 2026-10-01).
export const BULK_ACTIONS = [["remove_background", "Remove background", "AI · transparent"], ["packshot", "Packshot on white", "AI · centered, soft shadow"], ["brand_background", "Brand color background", "AI · uses the brand kit accent"], ["overlay_logo", "Add the logo", "Free · brand kit logo, bottom right"], ["badge", "Sale badge", "Free · brand accent pill"]];